import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { Shared_Service } from 'app/shared/shared.service';

@Component({
  selector: 'ashcorp-field-number',
  templateUrl: './ashcorp-field-number.component.html',
  animations: fuseAnimations
})

export class Ashcorp_Field_Number_Component {
  @Input() form: FormGroup;
  @Input() label: string;
  @Input() name: string;
  @Input() show?: boolean = true;
  @Input() readonly?: boolean = false;
  @Input() suffix?: Array<string> = null;

  public helper: Shared_Service;

  constructor(private _shared_service: Shared_Service) {
    this.helper = this._shared_service;
  }
}
